// removed by extract-text-webpack-plugin
module.exports = {"tweet-wrap":"tweet-wrap___-oO6y center___2iqBf","tweet-text":"tweet-text___pJdkx h3___5u0xZ","tweet-send":"tweet-send___3hKUy h3___5u0xZ undefined center___2iqBf hover-transition___1KXuM","social-icon-twitter-wrap":"social-icon-twitter-wrap___2q4lx center___2iqBf","social-icon-twitter":"social-icon-twitter___FJr-u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tweeter/Tweeter.css
// module id = 863
// module chunks = 0